import getSector from "../color/getSector";
import getSubsector from "../color/getSubsector";
import {
  getCancellationMonth,
  getCancellationQuarter,
  getCancellationWeek,
  getCancellationYear,
  getStageActualMonth,
  getStageActualQuarter,
  getStageActualWeek,
  getStageActualYear,
  getStageOriginalPlanMonth,
  getStageOriginalPlanQuarter,
  getStageOriginalPlanWeek,
  getStageOriginalPlanYear,
  getStagePlanMonth,
  getStagePlanQuarter,
  getStagePlanWeek,
  getStagePlanYear,
  L1PlanDate,
  L2PlanDate,
  L3PlanDate,
  L4PlanDate,
  L5PlanDate
} from "../Sort/checkDate/getDate";

// utils/groupInitiatives.js
const getCancellationDate = (initiative) => {
  const historyEntry = initiative.history?.find(
    (entry) =>
      entry.action?.includes('Weekly Status was changed from') &&
      entry.action?.includes('to Cancelled')
  );
  return historyEntry?.timestamp ? new Date(historyEntry.timestamp) : '<not set>';
};

const getQualitativeKPI = (initiative) => {
  const kpi = initiative.KPI?.find((k) => k.isFinancial);
  return kpi ? 'No' : 'Yes';
};

const getSegmentalPBT = (segmental) => {
  return segmental ? 'Yes' : 'No';
};

// Function to get ISO week number
const getISOWeek = (date) => {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  // Thursday in current week decides the year.
  d.setDate(d.getDate() + 3 - ((d.getDay() + 6) % 7));
  // January 4 is always in week 1.
  const week1 = new Date(d.getFullYear(), 0, 4);
  // Calculate the number of weeks between given date and week 1.
  return (
    1 +
    Math.round(((d.getTime() - week1.getTime()) / 86400000 - 3 + ((week1.getDay() + 6) % 7)) / 7)
  );
};

const groupInitiativesBy = (
  data,
  groupBy,
  determineStage,
  checkTOFinanceApprovalStatus,
  checkWorkstreamLeadApprovalStatus,
  checkWorkstreamSponsorApprovalStatus,
  getNetRecurringBenefitCatagory,
  InitiativePlanningSummary,
  planningSummarySimplified,
  l0ActualDate,
  l1ActualDate,
  l2ActualDate,
  l2PlanDate,
  l3ActualDate,
  l3PlanDate,
  l4ActualDate,
  l4PlanDate,
  l5ActualDate,
  l5PlanDate,
  L1OriginalPlanDate,
  L2OriginalPlanDate,
  L3OriginalPlanDate,
  L4OriginalPlanDate,
  L5OriginalPlanDate,
  LLatestActualDate,
  submittedForL1ApprovalPlanDate,
  submittedForL2ApprovalPlanDate,
  submittedForL3ApprovalPlanDate,
  submittedForL4ApprovalPlanDate,
  submittedForL5ApprovalPlanDate,
  getNetRecurringBenefitCatagoryL0Plus,
  getNetRecurringBenefitCatagoryL1Plus,
  getNetRecurringBenefitCatagoryL2Plus,
  getNetRecurringBenefitCatagoryL3Plus,
  getNetRecurringBenefitCatagoryL4Plus,
  getComplianceStatusForGrouping,
  groupInitiativesByYearActual,
  sortInitiativesByActuals,
  checkStrategyAnalystApprovalStatus,
  users,
  subworkstream,
  historyData,
  selectedRange,
  sortInitiativesByActualImpact,  // This appears only once now
  getImplementationCostCatagory,
  sumVisible,
  subsectorData
) => {
  if (
    groupBy === 'None' ||
    (Array.isArray(groupBy) &&
      groupBy.length === 0 &&
      Array.isArray(selectedRange) &&
      selectedRange.length === 0)
  ) {
    return { groupedData: {}, totals: {} };
  }

  const grouped = {};
  const totals = {};

  const startDate = selectedRange?.[0] ? new Date(selectedRange[0]) : null;
  const endDate = selectedRange?.[1] ? new Date(selectedRange[1]) : null;

  if (startDate || endDate) {
    historyData.forEach((historyEntry) => {
      const match = historyEntry.event && historyEntry.event.match(/New Initiative (\d+) Created/);
      if (match && match[1]) {
        const initiativeNumber = match[1];
        const initiative = data.find((item) => item.initiativeNumber === initiativeNumber);
        if (!initiative || !historyEntry.created) return;

        const createdDate = new Date(historyEntry.created);
        if (isNaN(createdDate.getTime())) return;

        const createdDateOnly = createdDate.toISOString().split('T')[0];

        const inRange =
          (!startDate || createdDate >= startDate) && (!endDate || createdDate <= endDate);

        if (inRange) {
          if (!grouped[createdDateOnly]) {
            grouped[createdDateOnly] = [];
            totals[createdDateOnly] = 0;
          }
          grouped[createdDateOnly].push(initiative);
          totals[createdDateOnly]++;
        }
      }
    });
  } else if (Array.isArray(groupBy) && groupBy.length > 0) {
    historyData.forEach((historyEntry) => {
      const match = historyEntry.event && historyEntry.event.match(/New Initiative (\d+) Created/);
      if (match && match[1]) {
        const initiativeNumber = match[1];
        const initiative = data.find((item) => item.initiativeNumber === initiativeNumber);
        if (initiative) {
          if (
            Array.isArray(groupBy) &&
            groupBy.every((item) => typeof item === 'string' || item instanceof Date)
          ) {
            const groupByDate = groupBy.find((ts) => {
              const groupByTs = new Date(ts);
              let historyTs;
              try {
                historyTs = new Date(historyEntry.created);
                if (isNaN(historyTs.getTime())) {
                  console.warn('Invalid date encountered:', historyEntry.created);
                  return false;
                }
              } catch (error) {
                console.error('Error creating date from:', historyEntry.created, error);
                return false;
              }
              return (
                groupByTs.getFullYear() === historyTs.getFullYear() &&
                groupByTs.getMonth() === historyTs.getMonth() &&
                groupByTs.getDate() === historyTs.getDate()
              );
            });

            if (groupByDate) {
              const groupByValue = new Date(groupByDate).toISOString().split('T')[0];
              if (!grouped[groupByValue]) {
                grouped[groupByValue] = [];
                totals[groupByValue] = 0;
              }
              grouped[groupByValue].push(initiative);
              totals[groupByValue]++;
            }
          } else if (initiative[groupBy] !== undefined) {
            const groupKey = initiative[groupBy];
            if (!grouped[groupKey]) {
              grouped[groupKey] = [];
              totals[groupKey] = 0;
            }
            grouped[groupKey].push(initiative);
            totals[groupKey]++;
          }
        }
      }
    });
  } else {
    data.forEach((initiative) => {
      const history = initiative.history || [];
      const impacts = initiative.impact || [];
      let initiativeGroupValue = null;

      // Handle groupBy that should be processed in the impacts loop first
      const isImpactBasedGrouping = [
        'frequencyAndDirectionBinned',
        'whosePandL',
        'Created on - Year',
        'Created on - Quarter',
        'Created on - Month',
        'Created on - Day',
        'Created on - YearWeek',
        'Created on - Week Day',
        'Updated on - Year',
        'Updated on - Quarter',
        'Updated on - Month',
        'Updated on - Day',
        'Updated on - YearWeek',
        'Updated on - Week Day'
      ].includes(groupBy);

      if (isImpactBasedGrouping) {
        // Handle impact-based grouping
        if (groupBy.startsWith('Created on -')) {
          const createdImpacts = history
            .filter((entry) => entry.action?.includes('New Financial Impact'))
            .map((entry) => {
              const timestamp = new Date(entry.timestamp);
              const impactNumber = entry.action.match(/Impact (\d+)/)?.[1];
              return { impactNumber, timestamp };
            });

          let groupValues = [];

          createdImpacts.forEach(({ impactNumber, timestamp }) => {
            const impact = impacts.find((imp) => imp.impactNumber === impactNumber);
            if (impact && timestamp) {
              let value;
              switch (groupBy) {
                case 'Created on - Year':
                  value = timestamp.getFullYear();
                  break;
                case 'Created on - Quarter':
                  value = `Q${Math.floor(timestamp.getMonth() / 3) + 1} ${timestamp.getFullYear()}`;
                  break;
                case 'Created on - Month':
                  value = timestamp.toLocaleString('default', { month: 'long' });
                  break;
                case 'Created on - Day':
                  value = timestamp.toISOString().split('T')[0];
                  break;
                case 'Created on - YearWeek':
                  const weekNumber = getISOWeek(timestamp);
                  value = `${timestamp.getFullYear()} - Week ${weekNumber}`;
                  break;
                case 'Created on - Week Day':
                  value = timestamp.toLocaleString('default', { weekday: 'long' });
                  break;
                default:
                  value = null;
              }
              if (value) {
                groupValues.push(value);
              }
            }
          });

          if (groupValues.length === 0) {
            groupValues = ['N/A'];
          }

          groupValues.forEach((value) => {
            if (!grouped[value]) {
              grouped[value] = [];
              totals[value] = 0;
            }
            if (!grouped[value].includes(initiative)) {
              grouped[value].push(initiative);
              totals[value]++;
            }
          });
          return;

        } else if (groupBy.startsWith('Updated on -')) {
          const updatedImpacts = history
            .filter(
              (entry) =>
                entry.action?.includes('Impact number') &&
                (entry.action?.includes('Recurring Negative Impact (ETB)') ||
                  entry.action?.includes('Recurring Benefit (ETB)') ||
                  entry.action?.includes('One Time Benefit'))
            )
            .map((entry) => {
              const timestamp = new Date(entry.timestamp);
              const impactNumber = entry.action.match(/Impact number (\d+)/)?.[1];
              return { impactNumber, timestamp };
            });

          let groupValues = [];

          updatedImpacts.forEach(({ impactNumber, timestamp }) => {
            const impact = impacts.find((imp) => imp.impactNumber === impactNumber);
            if (impact && timestamp) {
              let value;
              switch (groupBy) {
                case 'Updated on - Year':
                  value = timestamp.getFullYear();
                  break;
                case 'Updated on - Quarter':
                  value = `Q${Math.floor(timestamp.getMonth() / 3) + 1} ${timestamp.getFullYear()}`;
                  break;
                case 'Updated on - Month':
                  value = timestamp.toLocaleString('default', { month: 'long' });
                  break;
                case 'Updated on - Day':
                  value = timestamp.toISOString().split('T')[0];
                  break;
                case 'Updated on - YearWeek':
                  const weekNumber = getISOWeek(timestamp);
                  value = `${timestamp.getFullYear()} - Week ${weekNumber}`;
                  break;
                case 'Updated on - Week Day':
                  value = timestamp.toLocaleString('default', { weekday: 'long' });
                  break;
                default:
                  value = null;
              }
              if (value) {
                groupValues.push(value);
              }
            }
          });

          if (groupValues.length === 0) {
            groupValues = ['N/A'];
          }

          groupValues.forEach((value) => {
            if (!grouped[value]) {
              grouped[value] = [];
              totals[value] = 0;
            }
            if (!grouped[value].includes(initiative)) {
              grouped[value].push(initiative);
              totals[value]++;
            }
          });
          return;

        } else if (groupBy === 'frequencyAndDirectionBinned') {
          impacts.forEach((impact) => {
            const value = impact.frequencyAndDirection;
            if (value !== undefined && value !== null && value !== '') {
              if (!grouped[value]) {
                grouped[value] = [];
                totals[value] = 0;
              }
              if (!grouped[value].includes(initiative)) {
                grouped[value].push(initiative);
                totals[value]++;
              }
            }
          });
          return;

        } else if (groupBy === 'whosePandL') {
          impacts.forEach((impact) => {
            const workstreams = subworkstream?.find((sub) => sub._id === impact.workstream);
            const value = workstreams ? workstreams.subworkstreamName : '<not set>';
            if (!grouped[value]) {
              grouped[value] = [];
              totals[value] = 0;
            }
            if (!grouped[value].includes(initiative)) {
              grouped[value].push(initiative);
              totals[value]++;
            }
          });
          return;
        }
      }

      // Helper function to handle date-based grouping
      const handleDateGrouping = (groupByKey, dateValue, formatType) => {
        if (!dateValue || dateValue === '<not set>') return '<not set>';
        const date = new Date(dateValue);
        if (isNaN(date.getTime())) return '<not set>';

        switch (formatType) {
          case 'Year': return date.getFullYear();
          case 'Quarter': return `Q${Math.floor(date.getMonth() / 3) + 1} ${date.getFullYear()}`;
          case 'Month': return date.toLocaleString('default', { month: 'long' });
          case 'Week': return `${date.getFullYear()} - Week ${getISOWeek(date)}`;
          default: return dateValue;
        }
      };

      // Handle all other groupBy values
      if (groupBy === 'UniversalKPI') {
        const kpis = initiative.KPI || [];
        const universalKPIValues = [];

        kpis.forEach((kpi) => {
          if (kpi.UniversalKPI && kpi.UniversalKPI !== '' && kpi.UniversalKPI !== null) {
            universalKPIValues.push(kpi.UniversalKPI);
          }
        });

        // Remove duplicates for the same initiative (if an initiative has multiple KPIs with same UniversalKPI)
        const uniqueValues = [...new Set(universalKPIValues)];

        if (uniqueValues.length === 0) {
          // Initiative has no KPIs or no UniversalKPI values
          initiativeGroupValue = ['No Universal KPI'];
        } else {
          initiativeGroupValue = uniqueValues;
        }
      }
      else if (groupBy === 'total') {
        initiativeGroupValue = 'Total';
      } else if (groupBy === 'workstreamSponsorWorkstream') {
        if (initiative.workstreamSponsorWorkstream &&
          Array.isArray(initiative.workstreamSponsorWorkstream) &&
          initiative.workstreamSponsorWorkstream.length > 0) {
          initiativeGroupValue = initiative.workstreamSponsorWorkstream[0]?.workstreamName || 'N/A';
        } else {
          initiativeGroupValue = 'N/A';
        }
      } else if (groupBy === 'workstreamLeadSubworkstream') {
        if (initiative.workstreamLeadSubworkstream &&
          Array.isArray(initiative.workstreamLeadSubworkstream) &&
          initiative.workstreamLeadSubworkstream.length > 0) {
          initiativeGroupValue = initiative.workstreamLeadSubworkstream[0]?.subworkstreamName || 'N/A';
        } else {
          initiativeGroupValue = 'N/A';
        }
      } else if (groupBy === 'crossFunctionalSupportWorkstream') {
        if (initiative.crossFunctionalSupportWorkstreamInfo &&
          Array.isArray(initiative.crossFunctionalSupportWorkstreamInfo) &&
          initiative.crossFunctionalSupportWorkstreamInfo.length > 0) {
          initiativeGroupValue = initiative.crossFunctionalSupportWorkstreamInfo.map(
            (ws) => ws.subworkstreamName || 'N/A'
          );
        } else {
          initiativeGroupValue = ['N/A'];
        }
      } else if (groupBy === 'initiativeNumber - initiativeName') {
        initiativeGroupValue = `${initiative.initiativeNumber} - ${initiative.initiativeName}`;
      } else if (groupBy === 'sector') {
        const names = [];
        if (initiative?.sectorAccounts && Array.isArray(initiative.sectorAccounts)) {
          initiative.sectorAccounts.forEach((sec) => {
            if (sec?.sector && subsectorData && Array.isArray(subsectorData)) {
              const subsectorObj = subsectorData.find((sub) => sub._id === sec.sector);
              if (subsectorObj && subsectorObj.sector?.sectorName) {
                const nameValue = subsectorObj.sector.sectorName;
                if (nameValue && !names.includes(nameValue)) {
                  names.push(nameValue);
                }
              }
            }
          });
        }
        initiativeGroupValue = names.length > 0 ? names.join(', ') : '<not set>';
      } else if (groupBy === 'subsector') {
        const names = [];
        if (initiative?.sectorAccounts && Array.isArray(initiative.sectorAccounts)) {
          initiative.sectorAccounts.forEach((sec) => {
            if (sec?.sector && subsectorData && Array.isArray(subsectorData)) {
              const subsectorObj = subsectorData.find((sub) => sub._id === sec.sector);
              if (subsectorObj && subsectorObj.subsectorName) {
                const nameValue = subsectorObj.subsectorName;
                if (nameValue && !names.includes(nameValue)) {
                  names.push(nameValue);
                }
              }
            }
          });
        }
        initiativeGroupValue = names.length > 0 ? names.join(', ') : '<not set>';
      } else if (groupBy === 'type') {
        initiativeGroupValue = initiative.type || 'N/A';
      } else if (groupBy === 'size') {
        initiativeGroupValue = initiative.size || 'N/A';
      } else if (groupBy === 'segment') {
        initiativeGroupValue = initiative.segment || 'N/A';
      } else if (groupBy === 'initiativeCategory') {
        initiativeGroupValue = initiative.initiativeCategory || 'N/A';
      } else if (groupBy === 'stage') {
        initiativeGroupValue = determineStage(initiative);
      }
      else if (groupBy === 'Stage (simplified)') {
        initiativeGroupValue = initiative.stage || 'N/A';
      } else if (groupBy === 'workstreamLeadPendingApproval') {
        initiativeGroupValue = checkWorkstreamLeadApprovalStatus(initiative);
      } else if (groupBy === 'workstreamSponsorPendingApproval') {
        initiativeGroupValue = checkWorkstreamSponsorApprovalStatus(initiative);
      } else if (groupBy === 'financeLeadPendingApproval') {
        initiativeGroupValue = checkTOFinanceApprovalStatus(initiative);
      } else if (groupBy === 'Strategy analyst pending approval?') {
        initiativeGroupValue = checkStrategyAnalystApprovalStatus(initiative);
      } else if (groupBy === 'planningSummary') {
        initiativeGroupValue = InitiativePlanningSummary(initiative).planningStatus;
      }
      else if(groupBy === 'Planning summary (simplified)'){
        initiativeGroupValue=planningSummarySimplified(initiative)
      } else if (groupBy === 'netRecurringBenefitsRange') {
        initiativeGroupValue = getNetRecurringBenefitCatagory(initiative);
      } else if (groupBy === 'Future implementation costs range') {
        initiativeGroupValue = getImplementationCostCatagory(initiative);
      } else if (groupBy === 'l2LatestEstimatedDate' || groupBy === 'l2ForecastDate') {
        initiativeGroupValue = l2PlanDate(initiative);
      } else if (groupBy === 'L3 date compliance check (forecast vs planned date)') {
        initiativeGroupValue = getComplianceStatusForGrouping(initiative, 'L3');
      } else if (groupBy === 'L4 date compliance check (forecast vs planned date)') {
        initiativeGroupValue = getComplianceStatusForGrouping(initiative, 'L4');
      } else if (groupBy === 'Number of Attachment') {
        initiativeGroupValue = initiative.attachment?.length || 0;
      } else if (groupBy === 'actualImpactUpdateCheck' || groupBy === 'actualKpiUpdateCheck') {
        initiativeGroupValue = sortInitiativesByActualImpact(initiative, groupBy);
      } else if (groupBy === '(FY24-25) Actual impact update check') {
        initiativeGroupValue = groupInitiativesByYearActual(initiative, groupBy);
      } else if (groupBy === '(FY23-24) Actual impact update check') {
        initiativeGroupValue = groupInitiativesByYearActual(initiative, groupBy);
      } else if (groupBy === 'Has qualitative KPI?') {
        initiativeGroupValue = getQualitativeKPI(initiative);
      } else if (groupBy === 'segmentalPBT') {
        initiativeGroupValue = getSegmentalPBT(initiative?.segmentalPBT);
      } else if (groupBy === 'forSpecificCustomer') {
        initiativeGroupValue = getSegmentalPBT(initiative?.forSpecificCustomer);
      } else if (groupBy === 'hasFinancialImpact') {
        initiativeGroupValue = getSegmentalPBT(initiative?.hasFinancialImpact);
      } else if (groupBy === 'cancellationDate' || groupBy.startsWith('cancellationDate')) {
        if (groupBy === 'cancellationDate' || groupBy.endsWith('_Day')) {
          initiativeGroupValue = getCancellationDate(initiative);
        } else if (groupBy.endsWith('_Year')) {
          initiativeGroupValue = getCancellationYear(initiative);
        } else if (groupBy.endsWith('_Quarter')) {
          initiativeGroupValue = getCancellationQuarter(initiative);
        } else if (groupBy.endsWith('_Month')) {
          initiativeGroupValue = getCancellationMonth(initiative);
        } else if (groupBy.endsWith('_Week')) {
          initiativeGroupValue = getCancellationWeek(initiative);
        }
      } else if (groupBy === 'l3LatestEstimatedDate' || groupBy === 'l3ForecastDate' || groupBy === 'l3PlannedDate') {
        initiativeGroupValue = l3PlanDate(initiative);
      } else if (groupBy === 'L1 Original Planned Date' || groupBy.startsWith('L1 Original Planned Date')) {
        if (groupBy === 'L1 Original Planned Date' || groupBy.endsWith('_Day')) {
          initiativeGroupValue = L1OriginalPlanDate(initiative);
        } else if (groupBy.endsWith('_Week')) {
          initiativeGroupValue = getStageOriginalPlanWeek(initiative, 'L1');
        } else if (groupBy.endsWith('_Month')) {
          initiativeGroupValue = getStageOriginalPlanMonth(initiative, 'L1');
        } else if (groupBy.endsWith('_Quarter')) {
          initiativeGroupValue = getStageOriginalPlanQuarter(initiative, 'L1');
        } else if (groupBy.endsWith('_Year')) {
          initiativeGroupValue = getStageOriginalPlanYear(initiative, 'L1');
        }
      } else if (groupBy === 'L2 Original Planned Date' || groupBy.startsWith('L2 Original Planned Date')) {
        if (groupBy === 'L2 Original Planned Date' || groupBy.endsWith('_Day')) {
          initiativeGroupValue = L2OriginalPlanDate(initiative);
        } else if (groupBy.endsWith('_Week')) {
          initiativeGroupValue = getStageOriginalPlanWeek(initiative, 'L2');
        } else if (groupBy.endsWith('_Month')) {
          initiativeGroupValue = getStageOriginalPlanMonth(initiative, 'L2');
        } else if (groupBy.endsWith('_Quarter')) {
          initiativeGroupValue = getStageOriginalPlanQuarter(initiative, 'L2');
        } else if (groupBy.endsWith('_Year')) {
          initiativeGroupValue = getStageOriginalPlanYear(initiative, 'L2');
        }
      } else if (groupBy === 'L3 Original Planned Date' || groupBy.startsWith('L3 Original Planned Date')) {
        if (groupBy === 'L3 Original Planned Date' || groupBy.endsWith('_Day')) {
          initiativeGroupValue = L3OriginalPlanDate(initiative);
        } else if (groupBy.endsWith('_Week')) {
          initiativeGroupValue = getStageOriginalPlanWeek(initiative, 'L3');
        } else if (groupBy.endsWith('_Month')) {
          initiativeGroupValue = getStageOriginalPlanMonth(initiative, 'L3');
        } else if (groupBy.endsWith('_Quarter')) {
          initiativeGroupValue = getStageOriginalPlanQuarter(initiative, 'L3');
        } else if (groupBy.endsWith('_Year')) {
          initiativeGroupValue = getStageOriginalPlanYear(initiative, 'L3');
        }
      } else if (groupBy === 'L4 Original Planned Date' || groupBy.startsWith('L4 Original Planned Date')) {
        if (groupBy === 'L4 Original Planned Date' || groupBy.endsWith('_Day')) {
          initiativeGroupValue = L4OriginalPlanDate(initiative);
        } else if (groupBy.endsWith('_Week')) {
          initiativeGroupValue = getStageOriginalPlanWeek(initiative, 'L4');
        } else if (groupBy.endsWith('_Month')) {
          initiativeGroupValue = getStageOriginalPlanMonth(initiative, 'L4');
        } else if (groupBy.endsWith('_Quarter')) {
          initiativeGroupValue = getStageOriginalPlanQuarter(initiative, 'L4');
        } else if (groupBy.endsWith('_Year')) {
          initiativeGroupValue = getStageOriginalPlanYear(initiative, 'L4');
        }
      } else if (groupBy === 'L5 Original Planned Date' || groupBy.startsWith('L5 Original Planned Date')) {
        if (groupBy === 'L5 Original Planned Date' || groupBy.endsWith('_Day')) {
          initiativeGroupValue = L5OriginalPlanDate(initiative);
        } else if (groupBy.endsWith('_Week')) {
          initiativeGroupValue = getStageOriginalPlanWeek(initiative, 'L5');
        } else if (groupBy.endsWith('_Month')) {
          initiativeGroupValue = getStageOriginalPlanMonth(initiative, 'L5');
        } else if (groupBy.endsWith('_Quarter')) {
          initiativeGroupValue = getStageOriginalPlanQuarter(initiative, 'L5');
        } else if (groupBy.endsWith('_Year')) {
          initiativeGroupValue = getStageOriginalPlanYear(initiative, 'L5');
        }
      } else if (groupBy === 'l0ActualDate' || groupBy.startsWith('l0ActualDate')) {
        if (groupBy === 'l0ActualDate' || groupBy.endsWith('_Day')) {
          initiativeGroupValue = l0ActualDate(initiative);
        } else if (groupBy.endsWith('_Year')) {
          initiativeGroupValue = getStageActualYear(initiative, 'L0');
        } else if (groupBy.endsWith('_Month')) {
          initiativeGroupValue = getStageActualMonth(initiative, 'L0');
        } else if (groupBy.endsWith('_Quarter')) {
          initiativeGroupValue = getStageActualQuarter(initiative, 'L0');
        } else if (groupBy.endsWith('_Week')) {
          initiativeGroupValue = getStageActualWeek(initiative, 'L0');
        }
      } else if (groupBy === 'l1ActualDate' || groupBy.startsWith('l1ActualDate')) {
        if (groupBy === 'l1ActualDate' || groupBy.endsWith('_Day')) {
          initiativeGroupValue = l1ActualDate(initiative);
        } else if (groupBy.endsWith('_Year')) {
          initiativeGroupValue = getStageActualYear(initiative, 'L1');
        } else if (groupBy.endsWith('_Month')) {
          initiativeGroupValue = getStageActualMonth(initiative, 'L1');
        } else if (groupBy.endsWith('_Quarter')) {
          initiativeGroupValue = getStageActualQuarter(initiative, 'L1');
        } else if (groupBy.endsWith('_Week')) {
          initiativeGroupValue = getStageActualWeek(initiative, 'L1');
        }
      } else if (groupBy === 'l2ActualDate' || groupBy.startsWith('l2ActualDate')) {
        if (groupBy === 'l2ActualDate' || groupBy.endsWith('_Day')) {
          initiativeGroupValue = l2ActualDate(initiative);
        } else if (groupBy.endsWith('_Year')) {
          initiativeGroupValue = getStageActualYear(initiative, 'L2');
        } else if (groupBy.endsWith('_Month')) {
          initiativeGroupValue = getStageActualMonth(initiative, 'L2');
        } else if (groupBy.endsWith('_Quarter')) {
          initiativeGroupValue = getStageActualQuarter(initiative, 'L2');
        } else if (groupBy.endsWith('_Week')) {
          initiativeGroupValue = getStageActualWeek(initiative, 'L2');
        }
      } else if (groupBy === 'l3ActualDate' || groupBy.startsWith('l3ActualDate')) {
        if (groupBy === 'l3ActualDate' || groupBy.endsWith('_Day')) {
          initiativeGroupValue = l3ActualDate(initiative);
        } else if (groupBy.endsWith('_Year')) {
          initiativeGroupValue = getStageActualYear(initiative, 'L3');
        } else if (groupBy.endsWith('_Month')) {
          initiativeGroupValue = getStageActualMonth(initiative, 'L3');
        } else if (groupBy.endsWith('_Quarter')) {
          initiativeGroupValue = getStageActualQuarter(initiative, 'L3');
        } else if (groupBy.endsWith('_Week')) {
          initiativeGroupValue = getStageActualWeek(initiative, 'L3');
        }
      } else if (groupBy === 'l4ActualDate' || groupBy.startsWith('l4ActualDate')) {
        if (groupBy === 'l4ActualDate' || groupBy.endsWith('_Day')) {
          initiativeGroupValue = l4ActualDate(initiative);
        } else if (groupBy.endsWith('_Year')) {
          initiativeGroupValue = getStageActualYear(initiative, 'L4');
        } else if (groupBy.endsWith('_Month')) {
          initiativeGroupValue = getStageActualMonth(initiative, 'L4');
        } else if (groupBy.endsWith('_Quarter')) {
          initiativeGroupValue = getStageActualQuarter(initiative, 'L4');
        } else if (groupBy.endsWith('_Week')) {
          initiativeGroupValue = getStageActualWeek(initiative, 'L4');
        }
      } else if (groupBy === 'l5ActualDate' || groupBy.startsWith('l5ActualDate')) {
        if (groupBy === 'l5ActualDate' || groupBy.endsWith('_Day')) {
          initiativeGroupValue = l5ActualDate(initiative);
        } else if (groupBy.endsWith('_Year')) {
          initiativeGroupValue = getStageActualYear(initiative, 'L5');
        } else if (groupBy.endsWith('_Month')) {
          initiativeGroupValue = getStageActualMonth(initiative, 'L5');
        } else if (groupBy.endsWith('_Quarter')) {
          initiativeGroupValue = getStageActualQuarter(initiative, 'L5');
        } else if (groupBy.endsWith('_Week')) {
          initiativeGroupValue = getStageActualWeek(initiative, 'L5');
        }
      } else if (groupBy === 'latestActualDateAllLGates') {
        initiativeGroupValue = LLatestActualDate(initiative);
      } else if (groupBy === 'subForL1ApprovDate' || groupBy.startsWith('subForL1ApprovDate')) {
        if (groupBy === 'subForL1ApprovDate' || groupBy.endsWith('_Day')) {
          initiativeGroupValue = submittedForL1ApprovalPlanDate(initiative);
        } else if (groupBy.endsWith('_Year')) {
          initiativeGroupValue = getStageActualYear(initiative, 'Submitted for L1 Approval');
        } else if (groupBy.endsWith('_Quarter')) {
          initiativeGroupValue = getStageActualQuarter(initiative, 'Submitted for L1 Approval');
        } else if (groupBy.endsWith('_Month')) {
          initiativeGroupValue = getStageActualMonth(initiative, 'Submitted for L1 Approval');
        } else if (groupBy.endsWith('_Week')) {
          initiativeGroupValue = getStageActualWeek(initiative, 'Submitted for L1 Approval');
        }
      } else if (groupBy === 'subForL2ApprovDate' || groupBy.startsWith('subForL2ApprovDate')) {
        if (groupBy === 'subForL2ApprovDate' || groupBy.endsWith('_Day')) {
          initiativeGroupValue = submittedForL2ApprovalPlanDate(initiative);
        } else if (groupBy.endsWith('_Year')) {
          initiativeGroupValue = getStageActualYear(initiative, 'Submitted for L2 Approval');
        } else if (groupBy.endsWith('_Quarter')) {
          initiativeGroupValue = getStageActualQuarter(initiative, 'Submitted for L2 Approval');
        } else if (groupBy.endsWith('_Month')) {
          initiativeGroupValue = getStageActualMonth(initiative, 'Submitted for L2 Approval');
        } else if (groupBy.endsWith('_Week')) {
          initiativeGroupValue = getStageActualWeek(initiative, 'Submitted for L2 Approval');
        }
      } else if (groupBy === 'subForL3ApprovDate' || groupBy.startsWith('subForL3ApprovDate')) {
        if (groupBy === 'subForL3ApprovDate' || groupBy.endsWith('_Day')) {
          initiativeGroupValue = submittedForL3ApprovalPlanDate(initiative);
        } else if (groupBy.endsWith('_Year')) {
          initiativeGroupValue = getStageActualYear(initiative, 'Submitted for L3 Approval');
        } else if (groupBy.endsWith('_Quarter')) {
          initiativeGroupValue = getStageActualQuarter(initiative, 'Submitted for L3 Approval');
        } else if (groupBy.endsWith('_Month')) {
          initiativeGroupValue = getStageActualMonth(initiative, 'Submitted for L3 Approval');
        } else if (groupBy.endsWith('_Week')) {
          initiativeGroupValue = getStageActualWeek(initiative, 'Submitted for L3 Approval');
        }
      } else if (groupBy === 'subForL4ApprovDate' || groupBy.startsWith('subForL4ApprovDate')) {
        if (groupBy === 'subForL4ApprovDate' || groupBy.endsWith('_Day')) {
          initiativeGroupValue = submittedForL4ApprovalPlanDate(initiative);
        } else if (groupBy.endsWith('_Year')) {
          initiativeGroupValue = getStageActualYear(initiative, 'Submitted for L4 Approval');
        } else if (groupBy.endsWith('_Quarter')) {
          initiativeGroupValue = getStageActualQuarter(initiative, 'Submitted for L4 Approval');
        } else if (groupBy.endsWith('_Month')) {
          initiativeGroupValue = getStageActualMonth(initiative, 'Submitted for L4 Approval');
        } else if (groupBy.endsWith('_Week')) {
          initiativeGroupValue = getStageActualWeek(initiative, 'Submitted for L4 Approval');
        }
      } else if (groupBy === 'subForL5ApprovDate' || groupBy.startsWith('subForL5ApprovDate')) {
        if (groupBy === 'subForL5ApprovDate' || groupBy.endsWith('_Day')) {
          initiativeGroupValue = submittedForL5ApprovalPlanDate(initiative);
        } else if (groupBy.endsWith('_Year')) {
          initiativeGroupValue = getStageActualYear(initiative, 'Submitted for L5 Approval');
        } else if (groupBy.endsWith('_Quarter')) {
          initiativeGroupValue = getStageActualQuarter(initiative, 'Submitted for L5 Approval');
        } else if (groupBy.endsWith('_Month')) {
          initiativeGroupValue = getStageActualMonth(initiative, 'Submitted for L5 Approval');
        } else if (groupBy.endsWith('_Week')) {
          initiativeGroupValue = getStageActualWeek(initiative, 'Submitted for L5 Approval');
        }
      } else if (groupBy === 'l5ForecastDate' || groupBy.startsWith('l5ForecastDate')) {
        if (groupBy === 'l5ForecastDate' || groupBy.endsWith('_Day')) {
          initiativeGroupValue = l5PlanDate(initiative);
        } else if (groupBy.endsWith('_Year')) {
          initiativeGroupValue = getStagePlanYear(initiative, 'L5');
        } else if (groupBy.endsWith('_Quarter')) {
          initiativeGroupValue = getStagePlanQuarter(initiative, 'L5');
        } else if (groupBy.endsWith('_Month')) {
          initiativeGroupValue = getStagePlanMonth(initiative, 'L5');
        } else if (groupBy.endsWith('_Week')) {
          initiativeGroupValue = getStagePlanWeek(initiative, 'L5');
        }
      } else if (groupBy === 'l1PlannedDate' || groupBy.startsWith('l1PlannedDate')) {
        if (groupBy === 'l1PlannedDate' || groupBy.endsWith('_Day')) {
          initiativeGroupValue = L1PlanDate(initiative);
        } else if (groupBy.endsWith('_Year')) {
          initiativeGroupValue = getStagePlanYear(initiative, 'L1');
        } else if (groupBy.endsWith('_Quarter')) {
          initiativeGroupValue = getStagePlanQuarter(initiative, 'L1');
        } else if (groupBy.endsWith('_Month')) {
          initiativeGroupValue = getStagePlanMonth(initiative, 'L1');
        } else if (groupBy.endsWith('_Week')) {
          initiativeGroupValue = getStagePlanWeek(initiative, 'L1');
        }
      } else if (groupBy.startsWith('l4PlannedDate')) {
        if (groupBy.endsWith('_Day') || groupBy === 'l4PlannedDate') {
          initiativeGroupValue = L4PlanDate(initiative);
        } else if (groupBy.endsWith('_Year')) {
          initiativeGroupValue = getStagePlanYear(initiative, 'L4');
        } else if (groupBy.endsWith('_Quarter')) {
          initiativeGroupValue = getStagePlanQuarter(initiative, 'L4');
        } else if (groupBy.endsWith('_Month')) {
          initiativeGroupValue = getStagePlanMonth(initiative, 'L4');
        } else if (groupBy.endsWith('_Week')) {
          initiativeGroupValue = getStagePlanWeek(initiative, 'L4');
        }
      } else if (groupBy.startsWith('l3PlannedDate')) {
        if (groupBy.endsWith('_Day') || groupBy === 'l3PlannedDate') {
          initiativeGroupValue = L3PlanDate(initiative);
        } else if (groupBy.endsWith('_Year')) {
          initiativeGroupValue = getStagePlanYear(initiative, 'L3');
        } else if (groupBy.endsWith('_Quarter')) {
          initiativeGroupValue = getStagePlanQuarter(initiative, 'L3');
        } else if (groupBy.endsWith('_Month')) {
          initiativeGroupValue = getStagePlanMonth(initiative, 'L3');
        } else if (groupBy.endsWith('_Week')) {
          initiativeGroupValue = getStagePlanWeek(initiative, 'L3');
        }
      } else if (groupBy.startsWith('l2ForecastDate')) {
        if (groupBy.endsWith('_Day') || groupBy === 'l2ForecastDate') {
          initiativeGroupValue = l2PlanDate(initiative);
        } else if (groupBy.endsWith('_Year')) {
          initiativeGroupValue = getStagePlanYear(initiative, 'L2');
        } else if (groupBy.endsWith('_Quarter')) {
          initiativeGroupValue = getStagePlanQuarter(initiative, 'L2');
        } else if (groupBy.endsWith('_Month')) {
          initiativeGroupValue = getStagePlanMonth(initiative, 'L2');
        } else if (groupBy.endsWith('_Week')) {
          initiativeGroupValue = getStagePlanWeek(initiative, 'L2');
        }
      } else if (groupBy === 'pipelineWeeklyVarianceL0Plus') {
        initiativeGroupValue = getNetRecurringBenefitCatagoryL0Plus(initiative);
      } else if (groupBy === 'pipelineWeeklyVarianceL1Plus') {
        initiativeGroupValue = getNetRecurringBenefitCatagoryL1Plus(initiative);
      } else if (groupBy === 'pipelineWeeklyVarianceL2Plus') {
        initiativeGroupValue = getNetRecurringBenefitCatagoryL2Plus(initiative);
      } else if (groupBy === 'pipelineWeeklyVarianceL3Plus') {
        initiativeGroupValue = getNetRecurringBenefitCatagoryL3Plus(initiative);
      } else if (groupBy === 'pipelineWeeklyVarianceL4Plus') {
        initiativeGroupValue = getNetRecurringBenefitCatagoryL4Plus(initiative);
      } else if (groupBy === 'TO Finance Lead') {
        const toFinance = users?.find((u) => u.role?.name === 'TO Finance');
        initiativeGroupValue = toFinance ? `${toFinance.firstName} ${toFinance.lastName}` : 'N/A';
      } else if (
        groupBy === 'workstreamLeadInfo' ||
        groupBy === 'workstreamSponsorInfo' ||
        groupBy === 'initiativeOwnerInfo' ||
        groupBy === 'initiativeOwnerBackupInfo' ||
        groupBy === 'AllowOnlyTo'
      ) {
        const relatedPeople = initiative[groupBy];
        if (relatedPeople && Array.isArray(relatedPeople) && relatedPeople.length > 0) {
          initiativeGroupValue = relatedPeople.map(
            (person) => person ? `${person?.firstName || ''} ${person?.lastName || ''}`.trim() : 'N/A'
          ).filter(name => name !== '');
          if (initiativeGroupValue.length === 0) initiativeGroupValue = ['N/A'];
        } else {
          initiativeGroupValue = ['N/A'];
        }
      } else {
        initiativeGroupValue = initiative[groupBy] || 'N/A';
      }

      // Process the initiativeGroupValue
      if (Array.isArray(initiativeGroupValue) && initiativeGroupValue.length > 0) {
        initiativeGroupValue.forEach((val) => {
          const finalValue = val !== undefined && val !== null && val !== '' ? val : 'N/A';
          if (!grouped[finalValue]) {
            grouped[finalValue] = [];
            totals[finalValue] = 0;
          }
          if (!grouped[finalValue].includes(initiative)) {
            grouped[finalValue].push(initiative);
            totals[finalValue]++;
          }
        });
      } else {
        const finalValue = initiativeGroupValue !== undefined &&
          initiativeGroupValue !== null &&
          initiativeGroupValue !== ''
          ? initiativeGroupValue
          : 'N/A';
        if (!grouped[finalValue]) {
          grouped[finalValue] = [];
          totals[finalValue] = 0;
        }
        if (!grouped[finalValue].includes(initiative)) {
          grouped[finalValue].push(initiative);
          totals[finalValue]++;
        }
      }
    });
  }

  return { groupedData: grouped, totals };
};

export default groupInitiativesBy;